export default "__VITE_ASSET__D4q5w9t4__"